module.exports = __webpack_public_path__ + "img/diana_on.f659c553.webp";